import { render, staticRenderFns } from "./MainErrorDisplay.vue?vue&type=template&id=7ba478a4&scoped=true&"
import script from "./MainErrorDisplay.vue?vue&type=script&lang=js&"
export * from "./MainErrorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MainErrorDisplay.vue?vue&type=style&index=0&id=7ba478a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba478a4",
  null
  
)

export default component.exports